export async function closeIters(...iters) {
    await Promise.all(iters.map((i) => {
        i?.return?.();
    }));
}
//# sourceMappingURL=utils.mjs.map